import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'
import { no167Style } from '../../../components/Article/No167.style'
import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '2024お出かけイベント情報 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="にいがたイベントガイド" />
      <SectionTitle sectionTitle="2024お出かけイベント情報" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2024夏号 No.167 目次",
                path: "/no167"
              },
              {
                name: "イベントガイド"
              }
            ]}
          />
        <p>イベントなどは急きょ中止や変更となる場合があります。詳細は各施設にご確認ください。</p>
        
        <h3 css={style.subTitle01}>化石ハンター展～ゴビ砂漠の恐竜とヒマラヤの超大型獣～</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>9/23（月・振休）まで</h4>
        <p>休館：月（7/29、8/12、9/16、9/23は開館）<br />料金：一般1,800円、高校・大学生1,500円<br />※障害者手帳をお持ちの方は観覧料免除</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】県立万代島美術館（新潟市中央区） </span>&emsp;電話：<a href="tel:025-290-6655">025-290-6655</a><br />ホームページは<a href="https://banbi.pref.niigata.lg.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no167/img/2-5.png`}
          alt="化石ハンター展～ゴビ砂漠の恐竜とヒマラヤの超大型獣～"
          css={style.img(500, "15px 0 0 0")}
        />

        <hr />
        
        <h3 css={style.subTitle01}>とことん食虫植物展～ジャングルラボへようこそ！～</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>9/8（日）まで</h4>
        <p>休館：火<br />料金：一般600円、65歳以上500円、高校・大学生300円、小・中学生100円（土日祝日は小・中学生無料）</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】県立植物園（新潟市秋葉区） </span>&emsp;電話：<a href="tel:0250-24-6465">0250-24-6465</a><br />ホームページは<a href="https://botanical.greenery-niigata.or.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no167/img/2-6.png`}
          alt="とことん食虫植物展"
          css={style.img(500, "15px 0 0 0")}
        />

        <hr />
        
        <h3 css={style.subTitle01}>プラネタリウム夏の番組「新オーロラを見た恐竜たち～虹色に輝くアラスカの大地～」</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>9/16（月・祝）まで</h4>
        <p>休館：火（7/23、30、8/6、13、20は開館）<br />料金：一般790円、小・中学生200円</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】県立自然科学館（新潟市中央区） </span>&emsp;電話：<a href="tel:025-283-3331">025-283-3331</a><br />ホームページは<a href="https://www.sciencemuseum.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no167/img/2-7.png`}
          alt="&copy;D＆Dピクチャーズ"
          css={style.img(300, "15px 0 0 0")}
        />
        <p css={style.imgCap}>&copy;D＆Dピクチャーズ</p>
        <hr />
        
        <h3 css={style.subTitle01}>いきいきからだリフレッシュ教室</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>8/7（水）、16（金）、9/11（水）、20（金）、10/2（水）</h4>
        <p>簡単なストレッチやヨガを行います。<br />時間：13:00～14:00</p>
        
        <h3 css={style.subTitle01}>夏休みこども水泳教室</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>7/30（火）、31（水）、8/1（木）、2（金）</h4>
        <p>時間：①12:00～13:00&emsp;②16:30～17:30<br />料金：2,000円<br />対象：小学生から高校生の障害を有する方</p>
        
        <p><span css={no167Style.eventAddr}>【問い合わせ】新潟ふれ愛プラザ（新潟市江南区） </span>&emsp;電話：<a href="tel:025-381-8110">025-381-8110</a><br />ホームページは<a href="https://n-fureaiplaza.com/" target="_blank" rel="noreferrer">こちら</a></p>

        <hr />
        
        <h3 css={style.subTitle01}>第1回歴史講演会</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>9/21（土）13:30～15:30</h4>
        <p>戦国時代の越後を、古文書をもとに読み解きます。<br />講師：片桐昭彦（新潟大学人文社会科学系准教授）<br />定員：180人（申込先着順）<br />申込開始：8/21（水）～</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】県立文書館（新潟市中央区） </span>&emsp;電話：<a href="tel:025-284-6011">025-284-6011</a><br />ホームページは<a href="https://www.pref-lib.niigata.niigata.jp/1b8446f94c08f7ae67441d7d895601a6" target="_blank" rel="noreferrer">こちら</a></p>

        <hr />
        
        <h3 css={style.subTitle01}>まいぶん祭り</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>10/14（月・祝）</h4>
        <p>勾玉づくり、クイズでガチャなど<br />「花と遺跡の秋まつり」同時開催</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】県埋蔵文化財センター（新潟市秋葉区） </span>&emsp;電話：<a href="tel:0250-25-3981">0250-25-3981</a><br />ホームページは<a href="https://www.maibun.net/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no167/img/2-8.png`}
          alt="まいぶん祭り"
          css={style.img(500, "15px 0 0 0")}
        />

        <hr />
        
        <h3 css={style.subTitle01}>夏季企画展「大・佐渡島」</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>8/25（日）まで</h4>
        <p>休館：月（8/12は開館）<br />料金：一般840円、高校・大学生600円</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】県立歴史博物館（長岡市） </span>&emsp;電話：<a href="tel:0258-47-6130">0258-47-6130</a><br />ホームページは<a href="http://nbz.or.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no167/img/2-9.png`}
          alt="佐州全図（当館蔵）"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>佐州全図（当館蔵）</p>
        <hr />
        
        <h3 css={style.subTitle01}>猫の飼い方セミナー</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>8/17（土）13:30～15:30</h4>
        <p>（HPから申込先着順）</p>
        
        <h3 css={style.subTitle01}>犬の飼い方・しつけ方セミナー</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>10/14（月・祝）13:30～15:30</h4>
        <p>（HPから申込先着順）</p>
        
        <p><span css={no167Style.eventAddr}>【問い合わせ】県動物愛護センター（長岡市） </span>&emsp;電話：<a href="tel:0258-21-5501">0258-21-5501</a><br />ホームページは<a href="https://www.pref.niigata.lg.jp/site/da-top/" target="_blank" rel="noreferrer">こちら</a></p>

        <div>
        <img
          src={`${basePath}/no167/img/2-10.png`}
          alt="猫の飼い方セミナー"
          css={style.img(500, "15px 0 0 0")}
        />
        </div>
        <div>
        <img
          src={`${basePath}/no167/img/2-11.png`}
          alt="犬の飼い方・しつけ方セミナー"
          css={style.img(500, "15px 0 0 0")}
        />
        </div>

        <hr />
        
        <h3 css={style.subTitle01}>歴史の道八十里越『道の変遷』</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>9/23（月・振休）まで&emsp;ギャラリートーク（8/3、9/23）要事前申込</h4>
        <p>エコ・ミュージアムにて越後と会津を結ぶ歴史街道旧八十里峠に関するパネル展示解説とギャラリートークを実施。</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】浅草山麓エコ・ミュージアム（魚沼市） </span>&emsp;電話：<a href="tel:025-793-7480">025-793-7480</a><br />ホームページは<a href="https://www.eco-museum.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no167/img/2-12.png`}
          alt="歴史の道八十里越『道の変遷』"
          css={style.img(500, "15px 0 0 0")}
        />

        <hr />
        
        <h3 css={style.subTitle01}>王国夏まつり</h3>
        <h4 css={[style.subTitle02,no167Style.eventDate]}>8/11（日・祝）</h4>
        <p>遊びの縁日やおいしい屋台、夜は盆踊り大会を開催します。<br />体験ごとに料金が異なります。</p>
        <p><span css={no167Style.eventAddr}>【問い合わせ】こども自然王国（柏崎市） </span>&emsp;電話：<a href="tel:0257-41-3355">0257-41-3355</a><br />ホームページは<a href="https://www.garuru-kururu.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no167/img/2-13.png`}
          alt="王国夏まつり"
          css={style.img(500, "15px 0 0 0")}
        />

        <hr />
        
        
        <BackBtn href={"/no167"} />
      </Content>
    </Page>
  )
}
export default Home
